import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nav-tabs"
//
// The tab bar lives outside the members_section Turbo Frame, so clicking a tab
// (which only replaces that frame) does not re-render the tabs server-side.
// This controller mirrors the active styling client-side. The class lists must
// match members_helper#section_header_bar_class (the tab link) and
// #section_navbar_element_class (the count badge) so the optimistic toggle
// lines up with what the server renders on a full page load. (#573)
export default class extends Controller {
  static targets = ["tab"]

  // members_helper#section_header_bar_class
  static TAB_ACTIVE = ["bg-surface-warm", "text-accent"]
  static TAB_INACTIVE = ["text-ink-soft", "hover:bg-surface-warm", "hover:text-accent"]
  // members_helper#section_navbar_element_class
  static BADGE_ACTIVE = ["bg-accent", "text-white"]
  static BADGE_INACTIVE = ["bg-surface-warm", "text-ink-soft"]

  connect() {
    // Server-side sets the initial active state; nothing to do here.
  }

  activate(event) {
    // Don't prevent default — let Turbo handle the frame navigation. Apply the
    // visual styling immediately so the highlight moves before the list loads.
    this.tabTargets.forEach((tab) => this.style(tab, false))
    this.style(event.currentTarget, true)
  }

  style(tab, active) {
    const ctor = this.constructor
    tab.classList.remove(...(active ? ctor.TAB_INACTIVE : ctor.TAB_ACTIVE))
    tab.classList.add(...(active ? ctor.TAB_ACTIVE : ctor.TAB_INACTIVE))

    const badge = tab.querySelector(".mono-num")
    if (badge) {
      badge.classList.remove(...(active ? ctor.BADGE_INACTIVE : ctor.BADGE_ACTIVE))
      badge.classList.add(...(active ? ctor.BADGE_ACTIVE : ctor.BADGE_INACTIVE))
    }
  }
}
